export interface IBotones {
  PhoneSell?: number;
  Comprar?: number;
  Reservar?: number;
  Factura?: number;
  MisCompras?: number;
  MisReservas?: number;
  MisDatos?: number;
  MisOperaciones?: number;
  PayGold?: number;
  ComprarMas?: number;
  PagoDiferido?: number;
  Caducidad?: ICaducidad;
}

export const BOTONES_DEFAULT: Partial<IBotones> = {
  PhoneSell: 0,
  Comprar: 0,
  Reservar: 0,
  Factura: 0,
  MisCompras: 0,
  MisReservas: 0,
  MisDatos: 0,
  MisOperaciones: 0,
  PayGold: 0,
  ComprarMas: 0,
  PagoDiferido: 0
};

export interface ICaducidad {
  ModoAdmon?: IModoAdmon;
  FormasdePago?: IFormaPagoConfig[];
}

export interface IModoAdmon {
  Modificar?: IBotonConfig;
  Pagar?: IBotonConfig;
  Anular?: IBotonConfig;
}

export interface IBotonConfig {
  unidades?: number;
  tipo?: string;
  hora?: string;
}

export interface IFormaPagoConfig {
  CodigosFormaPago?: number[];
  Modificar?: IBotonConfig;
  Pagar?: IBotonConfig;
  Anular?: IBotonConfig;
}

export interface IEnlaceMenu {
  pkid:                   number;
  Activo:               string;
  Botones:               string | IBotones;
  Calendario:               ICalendario;
  ClaveEmpresa:               string;
  Descripcion:               string;
  DiasCalendario:                 string;
  GruposInternet:                 string;
  Idiomas:                 string;
  JSONConfiguracion:                 string;
  ListadoId:                 string;
  ListadoReservaId:                 string;
  Logueo:  string;
  Nivel:       string;
  Nombre:                 string;
  Orden:            string;
  Padre:                 boolean;
  SinFecha:                 boolean;
  SolicitaFactura:  string;
  SolicitaVerificarRegistro:  string;
  TipoEnlace:            string;
  Visible:                 string;
  TiposClientes:  string;
  VerCodigosPromocionales:  string;
  TiempoVentaMin:  string;
  TiempoVentaMinTipo:  string;
  TiempoVentaMax:  string;
  TiempoVentaMaxTipo:  string;
  TiempoReservaMin:  string;
  TiempoReservaMinTipo:  string;
  TiempoReservaMax:  string;
  TiempoReservaMaxTipo:  string;
  Audioguia: string;
}

export interface IEnlaceMenuFormValue {
  Activo:               string;
  Botones:               string;
  Calendario:               ICalendario;
  ClaveEmpresa:               string;
  Descripcion:               string;
  DiasCalendario:                 string;
  GruposInternet:                 string;
  Idiomas:                 string;
  JSONConfiguracion:                 string;
  ListadoId:                 string;
  ListadoReservaId:                 string;
  Logueo:  string;
  Nivel:       string;
  Nombre:                 string;
  Orden:            string;
  Padre:                 string;
  SinFecha:                 string;
  SolicitaFactura:  string;
  SolicitaVerificarRegistro:  string;
  TipoEnlace:            string;
  Visible:                 string;
  TiposClientes:  string;
  VerCodigosPromocionales:  string;
  TiempoVentaMin:  string;
  TiempoVentaMinTipo:  string;
  TiempoVentaMax:  string;
  TiempoVentaMaxTipo:  string;
  TiempoReservaMin:  string;
  TiempoReservaMinTipo:  string;
  TiempoReservaMax:  string;
  TiempoReservaMaxTipo:  string;
}

export interface IGetEnlaceMenuResponse {
  datosResult:            DatosResult;
  mensajes:               any[];
}

export interface DatosResult {
  listado: IEnlaceMenu[];
}


export interface IEnlaceMenuScript {
  "@context":          string;
  "@type":             string;
  name:                string;
  startDate:           string;
  endDate:             string;
  eventAttendanceMode?: string;
  eventStatus:         string;
  location:            Location;
  image:               string;
  description:         string;
  offers?:              Offers;
  organizer:           Organizer;
}

export interface Location {
  "@type": string;
  name:    string;
  address: Address;
}

export interface Address {
  "@type":         string;
  streetAddress:   string;
  addressLocality: string;
  addressRegion:   string;
  postalCode:      string;
  addressCountry:  string;
}

export interface Offers {
  "@type":       string;
  url:           string;
  price:         string;
  priceCurrency: string;
  availability:  string;
  validFrom:     string;
}

export interface Organizer {
  "@type": string;
  name:    string;
  url:     string;
}

export interface InsUpEnlaceMenuRequest {
  pkId?:                   number; // Cambiado de pkid a pkId (con mayúscula)
  Activo:               number | string;
  Botones:               IBotones; // Cambiado de string a objeto IBotones
  Calendario?:               ICalendario; // Opcional: solo se incluye si hay valores editados
  ClaveEmpresa:               string;
  Descripcion:               string;
  DiasCalendario:                 number | string;
  GruposInternet:                 any[];
  Idiomas:                 any[]; // Cambiado de string[] a any[] para incluir objetos
  JSONConfiguracion:                 any; // Cambiado de string a objeto
  ListadoId:                 number | string;
  ListadoReservaId:                 number | string;
  Logueo:  number | string;
  Nivel:       number | string;
  Nombre:                 string;
  Orden:            number | string;
  Padre:                 number | string;
  SinFecha:                 number | string;
  SolicitaFactura:  number | string;
  SolicitaVerificarRegistro:  number | string;
  TipoEnlace:            number | string;
  Visible:                 number | string;
  TiposClientes:  string;
  VerCodigosPromocionales:  number | string;
  TiempoVentaMin:  number | string;
  TiempoVentaMinTipo:  string;
  TiempoVentaMax:  number | string;
  TiempoVentaMaxTipo:  string;
  TiempoReservaMin:  number | string;
  TiempoReservaMinTipo:  string;
  TiempoReservaMax:  number | string;
  TiempoReservaMaxTipo:  string;

  Audioguia?: number | string;
  LetraLocalizador?: string;
}

export interface ICalendario {
    CaracteristicasCalendario: {
        Visibilidad: string;
        VisibilidadAngular: {
            Defecto: string;
            Paso1: string;
            Paso2: string;
        },
        CaledarioDisponible: string; // "0" o "1"
        FiltrosPorGI: {
            [key: string]: { // Dynamic keys for GI IDs or "0"
                NivelEducativo: number;
                RangoEdad: number;
                TipoTabla: number;
                CalendariosDia: number;
                IdiomaVisita: string[];
            }
        };
        GINoMostrarCalendario: number[];
        CalendarioPorRecintoGI: number[];
        CalendarioPorRecinto: number;
    }
}

export interface FiltrosPorGI {
  NivelEducativo: number;
  RangoEdad: number;
  TipoTabla: number;
  CalendariosDia: number;
  IdiomaVisita: string[];
  MostrarIdiomaSesion: number;
}

        //     "25": {
        //         "NivelEducativo": 1,
        //         "RangoEdad": 0,
        //         "TipoTabla": 0,
        //         "CalendariosDia": 0,
        //         "IdiomaVisita": [
        //             "es-ES",
        //             "en-GB",
        //             "fr",
        //             "de-DE"
        //         ]
        //     }
        // }


export interface InsUpEnlaceMenuResponse {
  datosResult: DatosResult;
  mensajes:    MensajeResult[];
}

export interface MensajeResult {
  codigoMensaje: string;
  descripcionMensaje: string;
}

export interface DatosResult {
  pkId: number;
}

// Interface for "Otras configuraciones" fields in CaracteristicasAdicionales
export interface IOtrasConfiguraciones {
  DobleLayoutEntradas?: number | string;
  ListaEspera?: number;
  CompraPases?: number;
  TiempoValidez?: number | string;
  TiempoValidezTipo?: string;
  AdmiteDtoPersonalizado?: number;
  AdmiteDescuentoPersonalizado?: number;
  AdmiteModelPersonalizado?: number;
  BloqueoInputFactura?: number;
  OcultarAreaPersonal?: number | string;
  APIPDFEntradas?: number | string;
  EnviarEmail?: number;
  CodigoClienteAsociado?: number;
  ImportacionExcelNominativas?: number;
  APIPDFFacturas?: number;
  APIPassbook?: number;
  FechaPorRecintoEnPdf?: number;
  MostrarAforoDisponible?: number;
  MostrarItinerario?: number;
  SinPhoneShell?: number;
  CorreoReservaSinTotales?: number;
  SinTituloExposicionEnResumen?: number;
  BotonMasMenosImagen?: number;
  OcultarClientesReservasAdmin?: number;
  TitularComoVisitante?: number;
  HoraFinEnSesionFija?: number;
  MailConfirmacionVentaOpcional?: number;
  MailConfirmacionReservaOpcional?: number;
  MostrarIncluyeComision?: number;
  OcultarTarifasSinTraduccion?: number;
  MostrarIdiomaSesion?: number;
  EnviarMailCC?: number;
  ListadoId?: number | string;
  ListadoReservaId?: number | string;
}
